/* @flow */
// typecheck: ignore file
import userAgent from 'lib/currentUserAgent';
import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

const RequireDesktop = {
  statics: {
    onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void) {
      const { query, pathname } = nextState.location;

      const deviceOkay = userAgent.isDesktop() || (userAgent.tablet() && userAgent.ie());

      if (!deviceOkay) {
        if (query && query.admin) {
          replaceWith({ pathname: '/schools_desktop', query });
        } else {
          query.path = pathname;
          replaceWith({ pathname: '/get_the_app', query });
        }
      }
    },
  },
};

export default RequireDesktop;



// WEBPACK FOOTER //
// ./src/components/mixins/RequireDesktop.js